<template>
    <div>
      <div>
        <vue-good-table
          :rows="getRows"
          :columns="columns"
          styleClass="vgt-table striped condensed"
        >
          <div slot="emptystate"></div>

          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label != 'after'">
              {{ $t(props.column.label) }}</span
            >
          </template>

          <template slot="table-row" slot-scope="props">
            <small>
              <span v-if="props.column.field == 'after'">
                <base-button
                  style="margin: 4px"
                  class="myButton"
                  size="sm"
                  type="primary"
                  @click="$router.push('/admin/scenarioeditor/edit/' + props.row.rps_scenario_id)"
                  >{{ $t("edit") }}</base-button
                >
                <br/>
                <base-button
                  style="margin: 4px"
                  class="myButton"
                  size="sm"
                  type="primary"
                  @click="$router.push('/admin/games/editphotos/' + props.row.rps_scenario_id)"
                  >{{ $t("edit-photos") }}</base-button
                >
                <br/>
                <base-button
                  style="margin: 4px"
                  class="myButton"
                  size="sm"
                  type="primary"
                  @click="toggleDraft(props.row.rps_scenario_id, props.row.draft)"
                  >{{ getTogglePublishString(props.row.rps_scenario_id) }}</base-button
                >
              </span>
              <span v-else-if="props.column.field == 'name'">
                {{ getScenarioName(props.row.rps_scenario_id) }}
              </span>

              <span v-else-if="props.column.field == 'draft'">
                <span v-if="isPublished(props.row.rps_scenario_id)">
                  <font-awesome-icon icon="check" style="color:green"/>
                </span>
              </span>

              <span v-else-if="props.column.field == 'photosok'">
                <span v-if="photosOk(props.row.rps_scenario_id)">
                  <font-awesome-icon icon="check" style="color:green"/>
                </span>                
              </span>
            </small>
          </template>
        </vue-good-table>
        <br />
      </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import {
  getRPSScenarios, 
  getRPSCases,
  updateRPSScenarioDraft,
} from "@/services/APIService";

const sortby = require("lodash.sortby");

export default {
  data() {
    return {
      columns: [
        {
          label: "name",
          field: "name",
        },
        {
          label: "published",
          field: "draft",
        },
        {
          label: "photosok",
          field: "photosok",
        },
        {
          label: "",
          field: "after",
          sortable: false,
        },
      ],
      rpsScenarios: [],
      rpsCases: [],
    };
  },
  components: {
    VueGoodTable,
  },
  mounted() {
    this.loadItems();
  },
  computed: {
    getRows() {
      // Since there is one scenario row for each locale,
      // let's return just one scenario entity for each
      // scenario
      const scenarios = [];

      // Let's first push exact matches:
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].locale === this.$i18n.locale) {
          scenarios.push(this.rpsScenarios[i]);
        }
      }

      // Then let's push the scenarios which do not exist in the selected $i18n locale:
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        const index = scenarios.findIndex(scenario => scenario.rps_scenario_id === this.rpsScenarios[i].rps_scenario_id);
        if (index === -1) {
          scenarios.push(this.rpsScenarios[i]);
        } else {
          // This scenario already exists
          continue;
        }
      }

      return sortby(scenarios, [
        (o) => {
          return o.short_description.toLowerCase();
        },
      ]);
    }
  },
  methods: {
    edit(id) {
      this.$router.push("/admin/games/edit/" + id);
    },
    photosOk(id) {
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].rps_scenario_id === id) {
          const scenario = this.rpsScenarios[i];
          if (!scenario.start_photo || !scenario.lobby_photo || !scenario.completion_photo) {
            return false;
          }
          break;
        }
      }

      for (let i = 0; i < this.rpsCases.length; i++) {
        if (this.rpsCases[i].rpsScenario === id) {
          const cases = this.rpsCases[i].rpsCases;
          
          for (let j = 0; j < cases.length; j++) {
            if (!cases[j].photo) {
              return false;
            }
          }
        }
      }

      return true;
    },
    isPublished(id) {
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].rps_scenario_id === id) {
          return !this.rpsScenarios[i].draft;
        }
      }
    },
    getScenarioName(id) {
      // Let's return name in some locale if no exact match
      let name = "";

      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].rps_scenario_id === id) {
          name = this.rpsScenarios[i].short_description

          if (this.rpsScenarios[i].locale === this.$i18n.locale) {
            // Found exact match
            break;
          }
        }
      }
      return name;
    },
    getTogglePublishString(id) {
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].rps_scenario_id === id) {
          if (this.rpsScenarios[i].draft) {
            return this.$t('publish')
          } else {
            return this.$t('unpublish')
          }
        }
      }
    },   
    async loadItems() {
      this.rpsScenarios = [];
      this.rpsCases = [];

      await getRPSScenarios(true).then((rpsScenarios) => {
        this.rpsScenarios = rpsScenarios;
      });

      // We need also cases for checking photos

      for (let i = 0; i < this.rpsScenarios.length; i++) {
        let skip = false;

        // Since we get one scenario for each available locale,
        // let's check if we already have cases for this scenario:
        for (let j = 0; j < this.rpsCases.length; j++) {
          if (this.rpsCases[j].rpsScenario === this.rpsScenarios[i].rps_scenario_id) {
            skip = true;
          }
        }

        if (skip) {
          continue;
        }

        const rpsCases = await (await getRPSCases(this.rpsScenarios[i].rps_scenario_id)).data;
        
        this.rpsCases.push({
          rpsScenario: this.rpsScenarios[i].rps_scenario_id,
          rpsCases: rpsCases
        })
      }
    },
    async toggleDraft(id, draft) {
      await updateRPSScenarioDraft(id, !draft);

      // Let's update scenarios
      for (let i = 0; i < this.rpsScenarios.length; i++) {
        if (this.rpsScenarios[i].rps_scenario_id === id) {
          this.rpsScenarios[i].draft = !draft;
        }
      }
    }
  },
};
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "published": "Published",
    "photosok": "Photos OK",
    "edit-photos": "Edit photos",
    "edit": "Edit simulation",
    "publish": "Publish",
    "unpublish": "Unpublish"
  },
  "fi": {
    "name": "Nimi",
    "published": "Julkaistu",
    "photosok": "Kuvat kunnossa",
    "edit-photos": "Muokkaa kuvia",
    "edit": "Muokkaa simulaatiota",
    "publish": "Julkaise",
    "unpublish": "Peru julkaisu"
  }
}
</i18n>
